<form [formGroup]="_form">
    <fieldset>
        <legend>{{formLabel}}</legend>
        <div fxLayout="row" class="padding-10" fxLayout.lt-md="column" fxLayoutGap="10px">

            <mat-form-field fxFlex>
                <mat-label> Field Name</mat-label>

                <mat-select [disableOptionCentering]="true" #singleSelect 
                formControlName="fieldName" required
                    autocomplete="off">
                    <mat-option>
                        <ngx-mat-select-search name="fieldName Search" ngDefaultControl
                            [formControl]="attributeFilterControl" placeholderLabel="Search"
                            [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let opt of filteredAttributeTypeList; let i=index;" [value]="opt.value">
                        {{opt.viewValue}}
                    </mat-option>

                  

                </mat-select>
                <mat-error *ngIf="_form.controls.fieldName.errors?.required">
                    Please fill out this field.
                </mat-error>

            </mat-form-field>

            <ng-container>
                <mat-form-field fxFlex  *ngIf="_form.value.fieldName!='createdDate'
                && _form.value.fieldName!='followUpDateTime'
                && _form.value.fieldName!='activityCountOnLead'
                &&_form.value.fieldName!='typeAndTime'
                &&_form.value.fieldName!='ownerEmail'
                &&_form.value.fieldName!='statusName'
                &&_form.value.fieldName!='sourceName'
                &&_form.value.fieldName!='callType'
                &&_form.value.fieldName!='status'
                &&_form.value.fieldName!='phoneCallOutcome'
                &&_form.value.fieldName!='category'
                &&_form.value.fieldName!='activityType'
                && _form.value.fieldName!='updatedDate'">
                    <mat-label>Condition</mat-label>
                    <mat-select formControlName="operators" name="item">
                        <mat-option *ngFor="let item of operators" [value]="item.value">
                            {{item.viewValue}}
                        </mat-option>
                        
                   
                    </mat-select>

                    <mat-error *ngIf="_form.controls.operators.errors?.required">
                        Please fill out this field.
                    </mat-error>
                </mat-form-field>

                <ng-container>
                    <mat-form-field fxFlex  *ngIf="
                    _form.value.fieldName=='ownerEmail'
                    ||_form.value.fieldName=='statusName'
                    ||_form.value.fieldName=='sourceName'
                    ||_form.value.fieldName=='callType'
                    ||_form.value.fieldName=='activityType'
                    ||_form.value.fieldName=='status'
                    ||_form.value.fieldName=='phoneCallOutcome'
                    ||_form.value.fieldName=='category'
                    
                    ">
                        <mat-label>Condition</mat-label>
                        <mat-select formControlName="operators" name="item">
                            <mat-option *ngFor="let item of operatorsText" [value]="item.value">
                                {{item.viewValue}}
                            </mat-option>
                        </mat-select>
    
                        <mat-error *ngIf="_form.controls.operators.errors?.required">
                            Please fill out this field.
                        </mat-error>
                    </mat-form-field>
                </ng-container>

                <mat-form-field fxFlex  *ngIf="_form.value.fieldName=='createdDate' 
                ||  _form.value.fieldName=='followUpDateTime'
                ||  _form.value.fieldName=='updatedDate'">
                    <mat-label>Condition</mat-label>
                    <mat-select formControlName="operators" name="item">
                        <mat-option *ngFor="let item of operatorsDate" [value]="item.value">
                            {{item.viewValue}}
                        </mat-option>
                       
                    </mat-select>
                    <mat-error *ngIf="_form.controls.operators.errors?.required">
                        Please fill out this field.
                    </mat-error>
                </mat-form-field>

                <mat-form-field fxFlex  *ngIf="
                _form.value.fieldName=='activityCountOnLead'
                ||_form.value.fieldName=='typeAndTime'
               
                ">
                    <mat-label>Condition</mat-label>
                    <mat-select formControlName="operators" name="item">
                        <mat-option *ngFor="let item of operatorsNuber" [value]="item.value">
                            {{item.viewValue}}
                        </mat-option>
                        
                    </mat-select>
                    <mat-error *ngIf="_form.controls.operators.errors?.required">
                        Please fill out this field.
                    </mat-error>
                </mat-form-field>
            </ng-container>


            <ng-container fxFlex="100">

                <mat-form-field fxFlex
                    *ngIf="_form.value.fieldName=='statusName' 
                    || _form.value.fieldName=='phoneCallOutcome' ">
                    <mat-label>Value</mat-label>
                    <mat-select formControlName="fieldValue" multiple [disableOptionCentering]="true">

                        <mat-option *ngFor="let opt of filtereddropdownTypeList; let i=index;" [value]="opt.statusName">
                            {{opt.statusName}}
                        </mat-option>

                     

                    </mat-select>
                    <mat-error *ngIf="_form.controls.fieldValue.errors?.required">
                        Please fill out this field.
                    </mat-error>
                </mat-form-field>

                <mat-form-field fxFlex *ngIf="_form.value.fieldName=='sourceName'">
                    <mat-label>Value</mat-label>
                    <mat-select formControlName="fieldValue" multiple [disableOptionCentering]="true">

                        <mat-option *ngFor="let opt of filteredLeadSourceTypeList; let i=index;"
                            [value]="opt.sourceName">
                            {{opt.sourceName}}
                        </mat-option>

                        
                    </mat-select>
                    <mat-error *ngIf="_form.controls.fieldValue.errors?.required">
                        Please fill out this field.
                    </mat-error>

                </mat-form-field>

                <mat-form-field fxFlex *ngIf="_form.value.fieldName=='ownerEmail'">
                    <mat-label>Value</mat-label>
                    <mat-select formControlName="fieldValue" multiple [disableOptionCentering]="true">

                        <mat-option *ngFor="let opt of filtereduserTypeList; let i=index;" [value]="opt.email">
                            {{opt.email}}
                        </mat-option>

                       
                    </mat-select>
                    <mat-error *ngIf="_form.controls.fieldValue.errors?.required">
                        Please fill out this field.
                    </mat-error>
                </mat-form-field>

                <mat-form-field fxFlex *ngIf="_form.value.fieldName=='callType'">
                    <mat-label>Value</mat-label>
                    <mat-select formControlName="fieldValue">
                        <mat-option *ngFor="let status of callTypeList" [value]="status.value">
                            {{status.viewValue}}
                        </mat-option>
                       
                    </mat-select>
                    <mat-error *ngIf="_form.controls.fieldValue.errors?.required">
                        Please fill out this field.
                    </mat-error>
                </mat-form-field>

                <mat-form-field fxFlex *ngIf="_form.value.fieldName=='status'">
                    <mat-label>Value</mat-label>
                    <mat-select formControlName="fieldValue">
                        <mat-option *ngFor="let status of selectList" [value]="status.value">
                            {{status.viewValue}}
                        </mat-option>
                        
                    </mat-select>
                    <mat-error *ngIf="_form.controls.fieldValue.errors?.required">
                        Please fill out this field.
                    </mat-error>
                </mat-form-field>


                <!-- <mat-form-field fxFlex
                    *ngIf="_form.value.fieldName=='activityCountOnLead'
                    ||_form.value.fieldName=='category'
                    ||_form.value.fieldName=='product'
                    ||_form.value.fieldName=='typeAndTime'
                    ||_form.value.fieldName=='City_cust'
                    ||_form.value.fieldName=='Country_cust'
                    ||_form.value.fieldName=='adGroupName_configurableProduct'
                    ">
                    <mat-label> Value </mat-label>
                    <input [attr.guide]="'database-rule-condition-advanced-inp-fieldvalue-1' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" matInput formControlName="fieldValue"/>
                    <mat-error *ngIf="_form.controls.fieldValue.errors?.required">
                        Please fill out this field.
                    </mat-error>
                </mat-form-field> -->

                <mat-form-field fxFlex
                    *ngIf="_form.value.fieldName!='statusName' && _form.value.fieldName!='sourceName' && _form.value.fieldName!='activityType' && _form.value.fieldName!='ownerEmail' 
                    && _form.value.fieldName!='phoneCallOutcome'
                    &&_form.value.fieldName !='category'
                    &&_form.value.fieldName !='product'
                    && _form.value.fieldName!='status'
                    && _form.value.fieldName!='callType'
                    && _form.value.fieldName!='createdDate'
                    && _form.value.fieldName!='followUpDateTime'
                    && _form.value.fieldName!='updatedDate' ">
                    <mat-label> Value </mat-label>
                    <input [attr.guide]="'database-rule-condition-advanced-inp-fieldvalue-1' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" [type]="isNumberField() ? 'number' : 'text'" [min]="isNumberField() ? 0 : null" (keydown)="preventNegative($event)" (input)="onFieldValueInput($event)" matInput formControlName="fieldValue"/>
                     <mat-error *ngIf="_form.controls.fieldValue.errors?.required">
                        Please fill out this field.
                    </mat-error>
                </mat-form-field>


                <!-- <mat-form-field fxFlex *ngIf="_form.value.fieldName=='createdDate' || _form.value.fieldName=='updatedDate'">
                    <mat-label>Date</mat-label>
                    <input [attr.guide]="'database-rule-condition-advanced-inp-fieldvalue-1' + '__' + sanitizeUrl(url)" (keydown)="disableTyping($event)" matInput [matDatepicker]="createDate"
                        formControlName="fieldValue"/>
                    <mat-datepicker-toggle  matSuffix
                        [for]="createDate"></mat-datepicker-toggle>
                    <mat-datepicker #createDate></mat-datepicker>
                </mat-form-field> -->

                <mat-form-field fxFlex
                    *ngIf="_form.value.fieldName === 'createdDate'
                    || _form.value.fieldName === 'followUpDateTime'
                    || _form.value.fieldName === 'updatedDate'">
                    <mat-label>Date</mat-label>
                    <mat-date-range-input [rangePicker]="picker" [formGroup]="_form">

                        <input [attr.guide]="'database-rule-condition-advanced-inp-startdate-1' + '__' + sanitizeUrl(url)" style="width: 100%;" disabled [autocomplete]="'off'" disabled
                                                       matStartDate
                                                        formControlName="startDate" placeholder="Start date"/>
                                                    <input [attr.guide]="'database-rule-condition-advanced-inp-enddate-1' + '__' + sanitizeUrl(url)" style="width: 100%;" [autocomplete]="'off'" disabled
                                                        (dateChange)="endDate()" matEndDate
                                                        formControlName="endDate" placeholder="End date"/>
                        <!-- <input [attr.guide]="'database-rule-condition-advanced-inp-startdate-1' + '__' + sanitizeUrl(url)" matStartDate placeholder="Start date" formControlName="startDate"/>
                        <input [attr.guide]="'database-rule-condition-advanced-inp-enddate-1' + '__' + sanitizeUrl(url)" matEndDate placeholder="End date" formControlName="endDate"/> -->
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                    <mat-error *ngIf="_form.controls.fieldValue.errors?.required">
                        Please fill out this field.
                    </mat-error>
                </mat-form-field>

                <ng-container *ngIf="_form.value.fieldName =='category'">
                    <mat-form-field fxFlex>
                        <mat-label>Value</mat-label>
                        <mat-select formControlName="fieldValue" 
                        [disableOptionCentering]="true" #singleSelect name="item">
                            <mat-option>
                                <ngx-mat-select-search name="Category Search" ngDefaultControl
                                    [formControl]="categoryFilterControl" placeholderLabel="Category Search"
                                    [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                                </ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let opt of filteredcategoryTypeList" [value]="opt.categoryName">
                                {{opt.categoryName}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="_form.controls.fieldValue.errors?.required">
                            Please fill out this field.</mat-error>
                    </mat-form-field>
                </ng-container>

                <ng-container *ngIf="_form.value.fieldName =='product'">

                   
                    <mat-form-field fxFlex >
                        <mat-label>Value</mat-label>
            
                            <input [attr.guide]="'database-rule-condition-advanced-inp-fieldvalue-1' + '__' + sanitizeUrl(url)" type="text" 
                            (input)="onInput($event)"
                            aria-label="Value"
                            matInput 
                            formControlName="fieldValue" 
                            [matAutocomplete]="auto"
                            
                          />
                        
                        <mat-autocomplete  #auto="matAutocomplete">
                            <mat-option   *ngFor="let option of productdropdownList"
                             [value]="option.name">
                                {{option.name}}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="_form.controls.fieldValue.errors?.required">
                            Please fill out this field.</mat-error>
                    </mat-form-field>
 
                </ng-container>


                <mat-form-field fxFlex *ngIf="_form.value.fieldName=='activityType'">

               
                    <mat-label>Value</mat-label>
                    <mat-select formControlName="fieldValue" [disableOptionCentering]="true">
                        <mat-option *ngFor="let opt of filteredActivityTypeList; let i=index;"
                            [value]="opt.activityType">
                            {{opt.activityType}}
                        </mat-option>

                    </mat-select>
                    <mat-error *ngIf="_form.controls.fieldValue.errors?.required">
                        Please fill out this field.
                    </mat-error>

                </mat-form-field>


            </ng-container>


            <button [attr.guide]="'database-rule-condition-advanced-btn-1-1' + '__' + sanitizeUrl(url)" mat-icon-button (click)="remove.emit()">
                <mat-icon color="warn">delete</mat-icon>
            </button>
        </div>
    </fieldset>
</form>